// extracted by mini-css-extract-plugin
export default {"container":"styleModule_container__CUKF5","title":"styleModule_title__kfiV-"};